// Sheet con las acciones disponibles al pulsar una línea del pedido.
//
// Tres acciones contextuales:
//   - cambiar-lote     → modal-cambiar-lote (afecta a los próximos escaneos)
//   - cambiar-cantidad → modal-editar-linea (PATCH /pedidos/{id}/lineas/{linea_id})
//   - quitar           → DELETE /pedidos/{id}/lineas/{linea_id}
//
// Resuelve con la acción elegida (string) o `null` si cancela.

import { icon } from './icons.js';

const escapeHtml = (s) => String(s ?? '').replace(/[&<>"']/g,
  c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

let _host = null;
function _close() { if (_host) { _host.remove(); _host = null; } }

export function openAccionesLineaModal({ linea }) {
  return new Promise((resolve) => {
    _host = document.createElement('div');
    document.body.appendChild(_host);

    const ref = escapeHtml(linea.barcode || `#${linea.producto_id}`);
    const desc = escapeHtml(linea.descripcion);

    const optBtn = (id, ico, title, sub, danger = false) => `
      <button data-action="${id}" style="
        display:flex; align-items:center; gap:0.7rem; width:100%;
        padding: 0.85rem 1rem;
        background: var(--c-surface);
        border: 1px solid var(--c-border);
        border-radius: var(--radius);
        text-align: left; cursor: pointer;
        color: ${danger ? 'var(--c-error)' : 'var(--c-fg)'};
      ">
        <span style="display:inline-flex;">${ico}</span>
        <span style="flex:1;">
          <strong>${title}</strong>
          <span style="display:block;color:var(--c-fg-muted);font-size:var(--fs-xs);">${sub}</span>
        </span>
      </button>`;

    _host.innerHTML = `
      <div class="scrim fade-in"><div class="modal">
        <h2>${desc}</h2>
        <p style="margin:0;color:var(--c-fg-muted);font-size:var(--fs-sm);">${ref}</p>
        <div style="display:flex;flex-direction:column;gap:0.5rem;">
          ${optBtn('cambiar-lote',     icon('tag', { size: 22 }),       'Cambiar lote',                'Para los próximos escaneos')}
          ${optBtn('cambiar-cantidad', icon('pencil', { size: 22 }),    'Cambiar cantidad pedida',     'Modifica la cantidad del pedido')}
          ${optBtn('quitar',           icon('trash-2', { size: 22 }),   'Quitar del pedido',           'Marca esta línea como eliminada', true)}
        </div>
        <div class="actions">
          <button class="btn --ghost --block" id="al-cancel">Cancelar</button>
        </div>
      </div></div>`;

    _host.querySelector('#al-cancel').addEventListener('click', () => { _close(); resolve(null); });
    _host.querySelectorAll('button[data-action]').forEach(b => {
      b.addEventListener('click', () => { _close(); resolve(b.dataset.action); });
    });
  });
}
